// Componentes pra mostrar valores das APIs com a ORIGEM (cor) e o PATH no tooltip.
// - source 'ml'  = Mercado Livre (âmbar)          'mp'  = MercadoPago (#3483fa)
// - source 'ext' = extrato MP/Release Report (teal) 'nfe' = NF-e/SEFAZ (violeta)
// - o `title` (tooltip) mostra o caminho exato na API (ex.: charges_details[2].amounts.original)
//   pra você consultar direto no Insomnia.

const SOURCE_CLASSES = {
    ml: 'text-amber-600 dark:text-amber-400',
    mp: 'text-[#3483fa]',
    ext: 'text-teal-600 dark:text-teal-400',
    nfe: 'text-violet-600 dark:text-violet-400',
};

export const SourceClass = (source) => SOURCE_CLASSES[source] || SOURCE_CLASSES.mp;

function formatLeaf(value) {
    if (value === null) return 'null';
    if (value === undefined) return '—';
    if (typeof value === 'boolean') return value ? 'true' : 'false';
    if (typeof value === 'object') return Array.isArray(value) ? '[ ]' : '{ }';
    if (value === '') return '""';
    return String(value);
}

// Um valor rotulado (label + valor colorido com path no title). Pra os "destaques".
export function ApiValue({ label, value, source = 'mp', path, format }) {
    const display = format ? format(value) : formatLeaf(value);
    return (
        <div className="min-w-0">
            {label ? <p className="truncate text-xs text-mono-500">{label}</p> : null}
            <p className={`truncate font-mono text-sm font-semibold ${SourceClass(source)}`} title={path}>
                {display}
            </p>
        </div>
    );
}

// Renderer RECURSIVO: mostra CADA valor do objeto, com o path no title e a cor da
// origem. Garante "todo e qualquer valor contemplado".
export function ApiValueTree({ data, source = 'mp', path = '', depth = 0 }) {
    const cls = SourceClass(source);

    if (data === null || typeof data !== 'object') {
        return (
            <span className={`font-mono ${cls}`} title={path || '(root)'}>
                {formatLeaf(data)}
            </span>
        );
    }

    const entries = Array.isArray(data)
        ? data.map((v, i) => [String(i), v, `${path}[${i}]`])
        : Object.entries(data).map(([k, v]) => [k, v, path ? `${path}.${k}` : k]);

    if (entries.length === 0) {
        return (
            <span className="font-mono text-mono-400" title={path}>
                {Array.isArray(data) ? '[ ]' : '{ }'}
            </span>
        );
    }

    return (
        <div className={depth === 0 ? '' : 'ml-2 border-l border-mono-200 pl-3 dark:border-mono-700'}>
            {entries.map(([key, value, childPath]) => {
                const isLeaf = value === null || typeof value !== 'object';
                return (
                    <div key={childPath} className="flex flex-wrap items-baseline gap-x-2 py-px text-sm">
                        <span className="text-xs text-mono-500" title={childPath}>
                            {key}:
                        </span>
                        {isLeaf ? (
                            <span className={`font-mono ${cls}`} title={childPath} data-api-path={childPath} data-source={source}>
                                {formatLeaf(value)}
                            </span>
                        ) : (
                            <ApiValueTree data={value} source={source} path={childPath} depth={depth + 1} />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
